import {
  ComponentProps,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react'

type Tenant = 'orsegups' | 'ubisafe'

const ALLOWED_TENANTS: Tenant[] = ['orsegups', 'ubisafe']

const ThemeContext = createContext<{
  tenant: Tenant
} | null>(null)

export const TenantProvider = (props: ComponentProps<'div'>) => {
  const [tenant, set] = useState<Tenant>('ubisafe')

  const getTenant = () => {
    const hostname = window.location.hostname
    const subdomain = hostname.split('.')[0]

    return subdomain
  }

  useEffect(() => {
    const tenant = getTenant()

    if (ALLOWED_TENANTS.includes(tenant)) {
      set(tenant)
      document.documentElement.setAttribute('tenant', tenant)
    } else {
      //remove when implementing tenant domain in url
      set(ALLOWED_TENANTS[0])
      document.documentElement.setAttribute('tenant', ALLOWED_TENANTS[0])
    }
  }, [])

  return <ThemeContext.Provider value={{ tenant }} {...props} />
}

export const useTenant = () => {
  const context = useContext(ThemeContext)

  if (!context) throw new Error('useTenant must be used within TenantProvider')

  return context
}
